export const COMPONENT_CLASS = 'specials-widget';
export const SPECIALS_LIST = 'specials-list';
export const SPECIALS_TITLE = 'specials.title';
export const SPECIALS_TITLE_ICON_CLASS_NAME = 'specials';
export const SPECIALS__ENDS_IN_LABEL = 'specials.ends_ind';
export const SPECIALS__ENHANCED_FROM_LABEL = 'specials.enhanced_from';

export const SPECIALS__SELECTION_TXT_CLASS_NAME = `${COMPONENT_CLASS}__selection-name`;
export const SPECIALS__EVENT_TXT_CLASS_NAME = `${COMPONENT_CLASS}__event-name`;
export const SPECIALS__COUNTDOWN_TXT_CLASS_NAME = `${COMPONENT_CLASS}__countdown`;
export const SPECIALS__OLD_PRICE_CONTAINER_CLASS_NAME = `${COMPONENT_CLASS}__oldprice-container`;
export const SPECIALS__OLD_PRICE_LABEL_CLASS_NAME = `${COMPONENT_CLASS}__oldprice-label`;
export const SPECIALS__OLD_PRICE_VALUE_CLASS_NAME = `${COMPONENT_CLASS}__oldprice-value`;

export const SPECIALS__WIDGET_CAROUSEL = `${COMPONENT_CLASS}-carousel`;
export const SPECIALS__WIDGET_CAROUSEL_NAV_PREV = `${SPECIALS__WIDGET_CAROUSEL}__prev`;
export const SPECIALS__WIDGET_CAROUSEL_NAV_NEXT = `${SPECIALS__WIDGET_CAROUSEL}__next`;

export const SPECIALS__LIST_MIN_LIMIT = 3;
export const SPECIALS__LIST_UNLIMITED = 0;

export const GTM_MAIN_COMPONENT = 'homepage';
export const GTM_SUB_COMPONENT = 'special-widget';
export const GTM_ACTION_SEE_ALL = 'see-all';
export const GTM_ACTION_SWIPE = 'swipe';
export const GTM_SPECIAL = 'Special';

export const POST_URL = '/sportsbook-req/getSpecialsEventsAjax';

//INSTRUCTION CARD
export const ZERO = 0;
export const I18N_INSTRUCTION_PREFIX = 'instruction_cards';
export const INSTRUCTION_CONTENT_MOBILE = `${I18N_INSTRUCTION_PREFIX}.specials_swipe`;
export const INSTRUCTION_CONTENT_WEB = `${I18N_INSTRUCTION_PREFIX}.specials_web`;
export const INSTRUCTION_FOOTER_TEXT = `${I18N_INSTRUCTION_PREFIX}.specials_footer`;
export const SPECIALS_INSTRUCTION_CARD = 'specials';
export const SPECIALS_SWIPER_DISMISS_GTM = 'instruction-special-swipe';
